import { getServiceDeskErrorMessage } from 'components/Error/ContactServiceDeskErrorMessage';

export function throwServerOrServiceDeskError(error, serviceDeskErrorPrefix) {
  if (error?.response?.status === 422 && error.response.data?.description) {
    throw error.response.data?.description;
  }
  throw getServiceDeskErrorMessage(serviceDeskErrorPrefix);
}
